import { FunctionComponent } from 'react';
import { Table } from 'components/tables/Table';
import { SubscriptionBundle } from 'domain/subscription/interfaces/SubscriptionBundle';
import { RequestStatus } from 'types/RequestStatus';
import { ColumnDef } from '@tanstack/react-table';
import { ExpandedBundleContent } from './ExpandedBundleContent/ExpandedBundleContent';

const BundleTable: FunctionComponent<{
	columns: ColumnDef<SubscriptionBundle, any>[];
	requestStatus: RequestStatus;
	bundles: SubscriptionBundle[];
	heading?: string;
	onRowClicked?: (bundle: SubscriptionBundle) => void;
}> = ({
	columns,
	requestStatus,
	bundles,
	heading = 'Subscription Bundles',
	onRowClicked,
}) => (
	<Table<SubscriptionBundle>
		header={heading}
		columns={columns}
		containerGap="xs"
		alternateRowBackground
		requestStatus={requestStatus}
		data={bundles}
		noDataText="No subscription bundles"
		paginationOptions={{ showFromCount: 10 }}
		withPagination
		onRowClicked={onRowClicked}
		expandedContent={(bundle) => <ExpandedBundleContent bundle={bundle} />}
	/>
);

export default BundleTable;
